export default {
  title: 'Receive tokens',
  close: 'Close receive address window',
  qrTitle: '{{source}} World Chain receiving address QR code',
  address: '{{source}} address',
  chainAddress: 'World Chain receiving address',
  copy: 'Copy address',
  copied: 'Address copied.',
  copyFailed: 'Unable to copy the address. Copy it manually.',
  unavailable: 'No receiving address is available for {{source}}. Connect MetaMask or sign in to get a World Chain wallet address.',
} as const;

